<template>
  <v-app>
    <default-bar />

    <default-drawer />

    <default-view />

    <default-footer />
  </v-app>
</template>

<script>
  import AppBar from './AppBar.vue'
  import Drawer from './Drawer.vue'
  import Footer from './Footer.vue'
  import View from './View.vue'

  export default {
    name: 'DefaultLayout',

    components: {
      DefaultBar: AppBar,
      DefaultDrawer: Drawer,
      DefaultFooter: Footer,
      DefaultView: View,
    },
  }
</script>
